(function () {
  const config = window.__variantBgConfig;
  if (!config) return;

  const productEl = document.getElementById(config.productElId);
  if (!productEl) return;

  const sectionEl = document.getElementById(config.sectionElId);
  const textColorEl = sectionEl ? sectionEl.querySelector('.section') || sectionEl : productEl;

  let selectedBgData = null;
  let selectedVariantObj = null;
  const productVariants = config.productVariants;
  const productOptionNames = config.productOptionNames;
  const priorityOptions = config.priorityOptions;

  let previewImg = null;
  let previewOriginalSrc = null;
  let previewOriginalSrcset = null;

  function getMainImg() {
    const carousel = productEl.querySelector('media-carousel');
    if (!carousel) return null;
    const mediaItems = Array.from(carousel.querySelectorAll('.product-gallery__media'));
    const thumbnails = Array.from(productEl.querySelectorAll('.product-gallery__thumbnail'));
    const activeIndex = thumbnails.findIndex(function (t) {
      return t.getAttribute('aria-current') === 'true';
    });
    const item = mediaItems[activeIndex >= 0 ? activeIndex : 0];
    return item ? item.querySelector('img') : null;
  }

  function switchGalleryImage(optionIndex, value, allowFallback) {
    if (!value) return;
    const match = findVariantForHoveredOption(optionIndex, value, allowFallback);
    if (!match || !match.featured_image) return;

    const img = getMainImg();
    if (!img) return;

    if (!previewImg) {
      previewImg = img;
      previewOriginalSrc = img.src;
      previewOriginalSrcset = img.srcset;
    }

    img.src = match.featured_image.src;
    img.srcset = '';
  }

  function restoreGalleryImage() {
    if (previewImg && previewOriginalSrc) {
      previewImg.src = previewOriginalSrc;
      previewImg.srcset = previewOriginalSrcset || '';
    }
    previewImg = null;
    previewOriginalSrc = null;
    previewOriginalSrcset = null;
  }

  const carouselFilterActive = priorityOptions.length > 0;

  function findVariantForHoveredOption(optionIndex, value, allowFallback) {
    if (optionIndex < 0) return null;

    const baseOptions = selectedVariantObj ? selectedVariantObj.options.slice() : [];
    if (baseOptions.length === 0) return null;

    baseOptions[optionIndex] = value;

    let match = productVariants.find(function (v) {
      return v.options.every(function (o, idx) {
        return o.toLowerCase() === baseOptions[idx].toLowerCase();
      });
    });

    if (!match && allowFallback) {
      match = productVariants.find(function (v) {
        return v.options[optionIndex].toLowerCase() === value.toLowerCase();
      });
    }

    return match || null;
  }

  function resetCarouselHeight() {
    document.querySelectorAll('media-carousel').forEach(function (c) {
      c.style.maxHeight = '';
    });
  }

  function switchCarouselMedia(optionIndex, value, allowFallback) {
    if (!value || !carouselFilterActive) return;
    if (typeof handleMediaChange !== 'function' || typeof filterMedia !== 'function') return;

    const match = findVariantForHoveredOption(optionIndex, value, allowFallback);
    if (!match) return;

    handleMediaChange();
    filterMedia(match.options, priorityOptions, match, productOptionNames);
    resetCarouselHeight();

    setTimeout(function () {
      const firstVisible = document.querySelector('.product-gallery__thumbnail:not([hidden])');
      if (firstVisible) firstVisible.click();
      resetCarouselHeight();
    }, 100);
  }

  function restoreCarouselMedia() {
    if (!selectedVariantObj || !carouselFilterActive) return;
    if (typeof handleMediaChange !== 'function' || typeof filterMedia !== 'function') return;

    handleMediaChange();
    filterMedia(selectedVariantObj.options, priorityOptions, selectedVariantObj, productOptionNames);
    resetCarouselHeight();

    setTimeout(function () {
      const firstVisible = document.querySelector('.product-gallery__thumbnail:not([hidden])');
      if (firstVisible) firstVisible.click();
      resetCarouselHeight();
    }, 100);
  }

  function hexToRgbChannels(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? parseInt(result[1], 16) + ' ' + parseInt(result[2], 16) + ' ' + parseInt(result[3], 16)
      : null;
  }

  function setColorVar(el, varName, hexValue) {
    if (hexValue) {
      const channels = hexToRgbChannels(hexValue);
      if (channels) {
        el.style.setProperty(varName, channels);
        return;
      }
    }
    el.style.removeProperty(varName);
  }

  function applyBackground(data) {
    const target = sectionEl || productEl;
    if (data && data.backgroundImage) {
      target.style.backgroundColor = '';
      target.style.backgroundImage = 'url(' + data.backgroundImage + ')';
      target.style.backgroundSize = 'cover';
      target.style.backgroundRepeat = 'no-repeat';
      target.style.backgroundPosition = 'center';
    } else if (data && data.backgroundHex) {
      target.style.backgroundImage = '';
      target.style.backgroundColor = data.backgroundHex;
    } else {
      target.style.backgroundImage = '';
      target.style.backgroundColor = '';
    }

    const buyBtn = productEl.querySelector('buy-buttons .button[type="submit"]');
    if (buyBtn) {
      if (data && data.addCartBackgroundColor === 'transparent') {
        buyBtn.style.setProperty('--button-background', '0 0 0 / 0');
        buyBtn.style.setProperty('--button-outline-color', '0 0 0 / 0');
      } else if (data && data.addCartBackgroundColor) {
        const bgChannels = hexToRgbChannels(data.addCartBackgroundColor);
        if (bgChannels) {
          buyBtn.style.setProperty('--button-background', bgChannels + ' / 1');
          buyBtn.style.setProperty('--button-outline-color', bgChannels);
        }
      } else {
        buyBtn.style.removeProperty('--button-background');
        buyBtn.style.removeProperty('--button-outline-color');
      }

      setColorVar(buyBtn, '--button-text-color', data && data.addCartTextColor);

      if (data && data.addCartBorderColor) {
        buyBtn.style.borderColor = data.addCartBorderColor;
        buyBtn.style.borderWidth = '2px';
        buyBtn.style.borderStyle = 'solid';
      } else {
        buyBtn.style.borderColor = '';
        buyBtn.style.borderWidth = '';
        buyBtn.style.borderStyle = '';
      }
    }

    if (textColorEl) {
      if (data && data.textColor) {
        textColorEl.classList.add('text-custom');
      }
      setColorVar(textColorEl, '--text-color', data && data.textColor);
      setColorVar(textColorEl, '--title-color', data && data.titleColor);
      setColorVar(textColorEl, '--price-color', data && data.priceColor);
      setColorVar(textColorEl, '--option-label-color', data && data.optionLabelColor);
      setColorVar(textColorEl, '--option-selected-color', data && data.optionSelectedColor);
      setColorVar(textColorEl, '--option-background-color', data && data.optionBackgroundColor);
      setColorVar(textColorEl, '--star-color', data && data.ratingColor);
    }
  }

  function findDataForOptions(options, backgrounds) {
    for (let i = 0; i < options.length; i++) {
      const match = backgrounds[options[i].toLowerCase()];
      if (match) return match;
    }
    return null;
  }

  const rawBackgrounds = config.rawBackgrounds;
  const backgrounds = {};
  Object.keys(rawBackgrounds).forEach(function (key) {
    backgrounds[key.toLowerCase()] = rawBackgrounds[key];
  });

  const initialVariant = config.initialVariant;
  if (initialVariant && initialVariant.options) {
    selectedBgData = findDataForOptions(initialVariant.options, backgrounds);
    selectedVariantObj = initialVariant;
    applyBackground(selectedBgData);
  }

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.options) return;
    previewImg = null;
    previewOriginalSrc = null;
    previewOriginalSrcset = null;
    selectedBgData = findDataForOptions(variant.options, backgrounds);
    selectedVariantObj = variant;
    applyBackground(selectedBgData);
  });

  const optionLabels = productEl.querySelectorAll('[data-option-value]');
  const hoveredContainers = new Set();

  function restoreAll() {
    applyBackground(selectedBgData);

    hoveredContainers.forEach(function (fieldset) {
      const optionValueEl = fieldset.querySelector('variant-option-value');
      if (optionValueEl && optionValueEl._originalText) {
        optionValueEl.textContent = optionValueEl._originalText;
        optionValueEl._originalText = null;
      }
    });
    hoveredContainers.clear();

    if (carouselFilterActive) {
      restoreCarouselMedia();
    } else {
      restoreGalleryImage();
    }
  }

  let colorOptionIndex = -1;
  for (let i = 0; i < productOptionNames.length; i++) {
    if (productOptionNames[i].toLowerCase() === 'color') {
      colorOptionIndex = i;
      break;
    }
  }

  optionLabels.forEach(function (label) {
    label.addEventListener('mouseenter', function () {
      const inputId = label.getAttribute('for');
      if (!inputId) return;
      const input = document.getElementById(inputId);
      if (!input) return;

      const inputName = input.getAttribute('name') || '';
      const match = inputName.match(/^option(\d+)$/);
      if (!match) return;
      const hoveredOptionIndex = parseInt(match[1], 10) - 1;
      const isColorOption = hoveredOptionIndex === colorOptionIndex;

      const value = input.value.toLowerCase();

      if (isColorOption) {
        const hoverData = backgrounds[value];
        applyBackground(hoverData || null);
      }

      const fieldset = label.closest('.variant-picker__option');
      if (fieldset) {
        const optionValueEl = fieldset.querySelector('variant-option-value');
        if (optionValueEl) {
          if (!optionValueEl._originalText) {
            optionValueEl._originalText = optionValueEl.textContent;
          }
          optionValueEl.textContent = input.value;
        }

        if (!hoveredContainers.has(fieldset)) {
          hoveredContainers.add(fieldset);
          fieldset.addEventListener('mouseleave', function onLeave() {
            fieldset.removeEventListener('mouseleave', onLeave);
            hoveredContainers.delete(fieldset);
            restoreAll();
          });
        }
      }

      if (carouselFilterActive) {
        switchCarouselMedia(hoveredOptionIndex, value, isColorOption);
      } else {
        switchGalleryImage(hoveredOptionIndex, value, isColorOption);
      }
    });
  });
})();
